export const contactoInputs = [
  { id: "email", label: "Email *" },
  { id: "nombre", label: "Nombre *" },
];
